import React, {useState} from "react";
import {reviews} from "./reviews";
import ReviewItem from "./reviewItem";
import {ReactComponent as Quote} from "./images/quote.svg";
import {ReactComponent as LeftArrow} from "./images/leftArrow.svg";
import {ReactComponent as RightArrow} from "./images/rightArrow.svg";
import Button from "./button";


const ReviewsCarousel = () => {
    const [isActiveSlide, setActiveSlide] = useState(1);

    function increment() {
        setActiveSlide(isActiveSlide + 1);
    }

    function decrement() {
        setActiveSlide(isActiveSlide - 1);
    }

    function handleClick(id) {
        return () => {
            setActiveSlide(id);
        }
    }

    return (
        <div className="bg-primaryBrand w-full text-white font-bold flex flex-col items-center md:py-28 md:px-20 py-16 px-12 relative lg:flex-row lg:justify-center">
            <LeftArrow className={"hidden absolute left-28 cursor-pointer lg:block" + (isActiveSlide <= 1 ? "hidden" : "")} onClick={decrement}/>
            <div className="flex flex-col gap-12 justify-center items-center w-full lg:w-3/5">
                <Quote className="hidden lg:block" />
                <div className="relative h-96 lg:h-44 w-full text-ellipsis overflow-y-hidden">
                    {reviews.map((review) => (
                        <ReviewItem key={review.id} review={review} active={isActiveSlide === review.id}/>
                    ))}
                </div>
                <Button to="/portfolio" label="See Case Studies" variant="dark-primary" isHashLink={false} />
                <div className="flex justify-center items-start absolute bottom-6 w-4/5 items-center lg:hidden">
                    {reviews.map((review) => (
                        <span key={review.id} className={"border-b-solid cursor-pointer border-b-white h-3 w-1/3" + (isActiveSlide === review.id ? " border-b-2" : " border-b")} onClick={handleClick(review.id)}></span>
                    ))}
                </div>
            </div>
            <RightArrow className={"hidden absolute right-28 cursor-pointer lg:block" + (isActiveSlide >= reviews.length ? "hidden" : "")} onClick={increment}/>
        </div>
    )
}

export default ReviewsCarousel;